import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

class LockDatesItem {
  constructor(selectedItems) {
    this.PlanningDetailIds = selectedItems.map((item) => item.PlanningDetailId);
    this.Confirmation = `This will lock the Start/End dates for ${selectedItems.length} item(s), preventing them from being edited.`;
  }
}

export default class LockDatesWindowDescription {
  static titleForCreate = 'Lock Dates';
  static titleForEdit = 'Lock Dates';
  static itemType = LockDatesItem;
  static serviceFunction = (item) => PlanningDetailsItemService.LockDates(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Confirm',
      fields: [
        {
          fieldName: 'Confirmation',
          label: 'Are you sure?',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
      ],
    },
  ];
}
